import React, { useContext, useState, useEffect } from 'react'
import 'C:/apps/ideafy/src/components/styles/MainPage.css'
import 'C:/apps/ideafy/src/components/styles/MainPageMobile.css'
import FirstSlide from './FirstSlide'
import SecondSlide from './SecondSlide'
import ThirdSlide from './ThirdSlide'
import FifthSlide from './FifthSlide'
import FourthSlide from './FourthSlide'




const MainPage = () => {
    return (
        <div className = 'main' >
            <FirstSlide/>
            <SecondSlide/>
            <ThirdSlide/>
            <FourthSlide/>
            <FifthSlide/>
        </div>
    
)}

export default MainPage
// {/* <Link to='/create'> Create a Post </Link> */}